var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.52 23.04C5.16792 23.04 0 17.8721 0 11.52C0 5.16792 5.16792 0 11.52 0C17.8721 0 23.04 5.16792 23.04 11.52C23.04 17.8721 17.8721 23.04 11.52 23.04ZM11.52 1.44C5.96184 1.44 1.44 5.96184 1.44 11.52C1.44 17.0782 5.96184 21.6 11.52 21.6C17.0782 21.6 21.6 17.0782 21.6 11.52C21.6 5.96184 17.0782 1.44 11.52 1.44ZM16.8821 16.4842C17.2378 16.3063 17.382 15.8738 17.2042 15.5182C17.137 15.384 15.5191 12.24 11.52 12.24C7.52088 12.24 5.90304 15.384 5.83584 15.5179C5.65872 15.8724 5.802 16.302 6.15552 16.4808C6.51 16.6591 6.94152 16.5178 7.12224 16.1652C7.17432 16.0637 8.4312 13.68 11.52 13.68C14.6088 13.68 15.8657 16.0637 15.9158 16.1621C16.0421 16.4146 16.2962 16.5605 16.5607 16.56C16.6687 16.56 16.7786 16.5358 16.8821 16.4842ZM15.12 10.08C14.3258 10.08 13.68 9.43416 13.68 8.64C13.68 7.84584 14.3258 7.2 15.12 7.2C15.9142 7.2 16.56 7.84584 16.56 8.64C16.56 9.43416 15.9142 10.08 15.12 10.08ZM7.92 10.08C7.12584 10.08 6.48 9.43416 6.48 8.64C6.48 7.84584 7.12584 7.2 7.92 7.2C8.71416 7.2 9.36 7.84584 9.36 8.64C9.36 9.43416 8.71416 10.08 7.92 10.08Z",
    fill: "#BD000B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSad);
export default __webpack_public_path__ + "static/media/Sad.006420c2dc180298f8211aa1916e0b1b.svg";
export { ForwardRef as ReactComponent };